module.exports = __webpack_public_path__ + "image/demo_2_1_460e5.jpeg";